import React, { useEffect, useState } from 'react';
import {
    Card, CardContent, Typography, TableCell, TableRow, TableBody, TableHead, Table,
    CircularProgress, Button, Paper, Tooltip, IconButton, Icon, Grid
} from '@material-ui/core';
import { darken } from '@material-ui/core/styles/colorManipulator';
import { FuseAnimate } from '@fuse';
import clsx from 'clsx';
import moment from 'moment';
import momentESLocale from "moment/locale/es";
import { makeStyles } from '@material-ui/styles';
import { useSelector } from 'react-redux';
import EmployeeService from 'app/services/EmployeeService/index';
import CompanyService from 'app/services/CompanyService/index';
import SignatureService from 'app/services/SignatureService/index';
import XmlService from 'app/services/XmlService/index';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useDispatch } from "react-redux";
import * as Actions from "app/store/actions";
import renderIf from "../Utils/renderIf";
import QRCode from 'qrcode.react';
import MessageService from 'app/services/MessageService';
import ModernInvoicePagePago from '../invoice-formats/ModernInvoicePagePago';
import ControlService from 'app/services/ControlService';
//import Iframe from 'react-iframe';

const useStyles = makeStyles(theme => ({
    root: {
        background: 'radial-gradient(' + darken(theme.palette.primary.dark, 0.5) + ' 0%, ' + theme.palette.primary.dark + ' 80%)'
    },
    divider: {
        backgroundColor: theme.palette.divider
    },
    dialogPaper: {
        width: '1500px'
    },
    signatureColumn: {
        [theme.breakpoints.down('sm')]: {
            paddingLeft: 20,
            textAlign: 'left !important',
            '& img': { // Alinear imágenes a la izquierda en móvil
                marginLeft: 0,
                marginRight: 'auto'
            }
        },
        textAlign: 'center'
    }
}));


function ModernInvoicePage(props) {
    const classes = useStyles();
    const dispatchMsg = useDispatch();

    const [openReject, setOpenReject] = useState(false);
    const [xmlId, handleXmlId] = useState(props.match.params.id);
    const [xml, handleXml] = useState([]);
    const [xmlDetails, handleXmlDetails] = useState([]);
    const [firmas, handleFirmas] = useState([]);
    const [firmasHolografas, handleFirmasHolografas] = useState([]);
    const [hashKude, setHashKude] = useState("");
    const [rejections, handleRejections] = useState([]);
    const [rejectionMessage, handleRejectionMessage] = useState();
    const [deactivateOpen, setDeactivateOpen] = useState(false);
    const [motivoDesactivacion, handleMotivoDesactivacion] = useState();
    const [firmasView, handleFirmasView] = useState({});
    const [company, handleCompany] = useState({});
    const [employee, handleEmployee] = useState({});
    const [documentos, handleDocuments] = useState({});
    const [buttonFirmar, toggleButtonFirmar] = useState("disabled");
    const [control, handleControl] = useState([]);
    const [buttonStateDownloadPdf, handleButtonStateDownloadPdf] = useState(false)
    const [buttonStateDownloadXml, handleButtonStateDownloadXml] = useState(false)
    const [signature_employee, handlesignature_employee] = useState(false)

    const user = useSelector(({ auth }) => auth.user);
    let userEmail = user.data.email;
    let userProfile = user.role[0];

    function message(type = "null", message = "") {
        dispatchMsg(
            Actions.showMessage({
                message: message,
                autoHideDuration: 6000, //ms
                anchorOrigin: {
                    vertical: "top", //top bottom
                    horizontal: "center" //left center right
                },
                variant: type //success error info warning null
            })
        );
    }

    /* if (window.location.pathname.split('/').length > 3) {
        //message('error', "status: " + window.location.pathname.split('/')[3])
        let status = window.location.pathname.split('/')[3]
        if (status == 'success') {
            message('success', "Documento firmado exitósamente")
        } else {
            message('error', "Ocurrió un error inesperado, contácte con el administrador")
        }
    } */

    async function LoadXML() {
        let responseXML = await XmlService.getXmlById(xmlId);
        let sign = await ControlService.getControlSigners();
        let control = await ControlService.getControl();
        let responseDocuments = await XmlService.getDocuments(xmlId);
        let rejections = await XmlService.getRejections(xmlId)
        if (rejections.data.status == 'success') {
            handleRejections(rejections.data.data)
        }

        let xml = responseXML.data.data[0]
        handlesignature_employee(xml.signature_employee)
        handleControl(control.data.data[0])

        if (responseXML.status === 200) {
            setHashKude(xml.id);

            let responseXMLType = await XmlService.getTypeXmls(xml.identificator);

            if (responseXMLType.data.data.length > 0) {
                var descripcion = responseXMLType.data.data[0].descripcion
            } else {
                var descripcion = ''
            }

            var processedXML = {
                fecha_de_pago: xml.fecha_de_pago.split('T')[0],
                mes_de_pago: xml.mes_de_pago,
                total_ingresos: xml.total_ingresos,
                total_ingresos_no: xml.total_ingresosno,
                total_retenciones: xml.total_retenciones,
                total_neto: xml.total_neto,
                neto_en_letras: xml.neto_en_letras,
                status: xml.status,
                periodo: xml.periodo,
                motivoDesactivacion: xml.motivoDesactivacion,
                numero_recibo: xml.numero_recibo,
                identificator: descripcion,
                salario_mensual: xml.salario_mensual
            }

            const firmas = {
                rrhh: xml.signature_rrhh === true ? "Firmado: " + moment(xml.signature_rrhh_datetime).format('DD/MM/YYYY HH:mm:ss') + " por " + xml.signature_rrhh_name : "No Firmado",
                director: xml.signature_director === true ? "Firmado: " + moment(xml.signature_director_datetime).format('DD/MM/YYYY HH:mm:ss') + " por " + xml.signature_director_name : "No Firmado",
                empleado: xml.signature_employee === true ? "Firmado: " + moment(xml.signature_employee_datetime).format('DD/MM/YYYY HH:mm:ss') + " por " + xml.signature_employee_name : "No Firmado",
            }

            let firmasHolografas = {
                rrhh: xml.signature_rrhh_holograph,
                director: xml.signature_director_holograph,
                empleado: xml.signature_employee_holograph,
            }

            let firmasView = {
                rrhh_view: false,
                director_view: false,
                empleado_view: false
            }

            for (let i = 0; i < sign.data.data.length; i++) {
                if (sign.data.data[i].sign_name == 'Funcionario') {
                    firmasView.empleado_view = true;
                }
                if (sign.data.data[i].sign_name == 'Director') {
                    firmasView.director_view = true;
                }
                if (sign.data.data[i].sign_name == 'RH') {
                    firmasView.rrhh_view = true;
                }
            }


            //console.log(user.role[0])
            //HABILITA OU DESABILITA O BOTÃO DE FIRMAR
            if (rejections.data.data.length > 0) {
                toggleButtonFirmar("disabled");
            } else if (user.role[0] === "rh" && xml.signature_rrhh === true) {
                toggleButtonFirmar("disabled");
            } else if (user.role[0] === "rh" && xml.signature_rrhh === false && responseDocuments.data.data[0].status != 'DES' && firmasView.rrhh_view === true) {
                toggleButtonFirmar("");
            } else if (user.role[0] === "director" && xml.signature_director === true) {
                toggleButtonFirmar("disabled");
            } else if (user.role[0] === "director" && xml.signature_director !== true && responseDocuments.data.data[0].status != 'DES') {
                toggleButtonFirmar("");
            } else if (user.role[0] === "funcionario" && xml.signature_employee === true) {
                toggleButtonFirmar("disabled");
            } else if (user.role[0] === "funcionario" && xml.signature_director === true) {
                toggleButtonFirmar("");
            } else if (user.role[0] === "funcionario" && xml.signature_director !== true) {
                toggleButtonFirmar("disabled");
            } else if (user.role[0] !== "rh" && user.role[0] !== "director" && user.role[0] !== "funcionario") {
                toggleButtonFirmar("disabled");
            }

            handleXml(processedXML);
            handleFirmas(firmas);
            handleFirmasHolografas(firmasHolografas);
            handleFirmasView(firmasView);
        } else {
            message('error', responseXML.data)
        }
    }

    useEffect(() => {
        loadAll();
    }, []);

    async function loadAll() {

        async function LoadCompany(mtess) {

            let responseCompany = await CompanyService.getCompanyMTESS(mtess);

            if (responseCompany) {
                if (responseCompany.status === 200) {
                    var processedCompany = {
                        razon_social: responseCompany.data.data[0].razon_social,
                        ruc: responseCompany.data.data[0].ruc,
                        dv: responseCompany.data.data[0].dv,
                        logo: responseCompany.data.data[0].logo,
                        website: "" //responseCompany.data[0].company.website
                    }
                    handleCompany(processedCompany);
                } else {
                    message('error', 'Registro de la empresa no encontrado')
                }
            }
        }

        async function LoadEmployee() {
            let responseEmployee = await EmployeeService.getEmployeeByXmlId(xmlId);
            //console.log(responseEmployee)
            if (responseEmployee.status === 200) {
                let employee = responseEmployee.data.data
                if (employee) {

                    var processedEmployee = {
                        nombres: employee.nombres,
                        apellidos: employee.apellidos,
                        identification: employee.identification,
                        legajo: employee.legajo,
                        ips_empleado: employee.ipsEmpleado,
                        mtess_patronal: employee.mtessPatronal,
                        email: employee.email,
                        departamento: employee.departamento,
                        cargo: employee.cargo,
                        sucursal: employee.sucursal,
                        sueldoJornal: employee.sueldoJornal,
                        number_count: employee.numberCount,
                        cert_type: employee.desc_cert_type
                    }
                    //console.log(processedEmployee)
                    handleEmployee(processedEmployee);
                    return processedEmployee;

                } else {
                    message('error', "No se puede visualizar el recibo, Verifique los datos del empleado!")
                }

            } else {
                message('error', responseEmployee.data)
            }
        }

        async function LoadXMLDetails() {

            let responseXMLDetails = await XmlService.getXmlDetails(xmlId);

            let dataXmlDetails = responseXMLDetails.data.data

            if (responseXMLDetails.status === 200) {

                let xmlDetails = [];

                for (let i = 0; i < dataXmlDetails.length; i++) {

                    let xmlDetailsProcessed = {
                        descripcion: dataXmlDetails[i].descripcion,
                        codigo: dataXmlDetails[i].codigo,
                        aclaracionConcepto: dataXmlDetails[i].aclaracionConcepto,
                        cantidad: dataXmlDetails[i].cant,
                        ingresos: dataXmlDetails[i].ingresos,
                        ingresosno: dataXmlDetails[i].ingresosno,
                        unidade: dataXmlDetails[i].unidade,
                        retenciones: dataXmlDetails[i].retenciones
                    }

                    xmlDetails.push(xmlDetailsProcessed)

                }

                handleXmlDetails(xmlDetails);

            } else {

                message('error', 'No se pudo recuperar el detalle del recibo!, verifique el log de errores')

            }
        }

        async function LoadDocument() {

            let responseDocuments = await XmlService.getDocuments(xmlId);
            if (responseDocuments.status === 200) {

                var fecha_inicial = responseDocuments.data.data[0].start_date.split("T")[0]
                var fecha_final = responseDocuments.data.data[0].end_date.split("T")[0]
                var processedDocuments = {
                    fecha_inicial: fecha_inicial,
                    fecha_final: fecha_final,
                    observacion: responseDocuments.data.data[0].observation
                }
                handleDocuments(processedDocuments);
                return processedDocuments;
            } else {
                message('error', responseDocuments.data.message)
            }

        }

        await LoadEmployee().then(async (employeeMTESS) => {

            if (userProfile == 'funcionario') {
                if (employeeMTESS.email != userEmail) {
                    console.log("acceso no permitido a recibo de otro funcionario")
                    props.history.push('/dashboard');
                }
            }

            if (employeeMTESS == undefined) {
                console.log("No se pudo visualizar el recibo");
            } else {
                await LoadCompany(employeeMTESS.mtess_patronal);
                await LoadDocument();
                await LoadXML();
                await LoadXMLDetails();
            }

        });
    }

    async function handleDeactivateCancelClose() {
        setDeactivateOpen(false);
    }

    async function handleDeactivateClose() {
        setDeactivateOpen(false);
        if (motivoDesactivacion != "") {
            deactivateDocument()
        }
    }

    async function deactivateDocument() {
        const response = await XmlService.deactivateDocument(xmlId, motivoDesactivacion)

        if (response.data.message == 'success') {
            await LoadXML()
            return message("success", response.data.message);
        } else {
            return message("error", response.data.message);
        }

    }

    async function handleNotificar() {
        let data = {
            from: userEmail,
            profile: userProfile,
            xmlId: xmlId
        };

        await MessageService.SendReminder(data).then(response => {
            if (response.status != 200) {
                message('error', response.data.message);
            } else {
                message('success', response.data.message);
            }
        });

    }

    async function handleClickOpen() {
        //se inicia la sesion de firma
        var data = {
            xmlId
        }

        var windowReference = window.open();

        const response = await SignatureService.SignatureSession(data)

        if (response.data.status == 'success') {
            //se captura el id de la sesion
            getSessionId(response.data.session_id)

            setTimeout(() => {
                windowReference.location = response.data.auth[0]._authUrl
                //window.close()
            }, 1000);

            //handleAuthUrl(response.data.auth[0]._authUrl)
        } else {
            message("error", response.data.message);
        }
    }

    async function getSessionId(id) {
        var data = {
            session_id: id,
            userEmail,
            userProfile,
            xmlId,
            tipo: 'recibos-sign'
        };
        await SignatureService.getSessionId(data);

    }

    /* async function sign(sessionInfo, id) {
        //console.log(sessionInfo)
        var code = sessionInfo[0].code;
        var state = sessionInfo[0].state;
        var key = process.env.REACT_APP_KEY_PASS;
        var email = aes256.encrypt(key, userEmail);
        var perfil = aes256.encrypt(key, userProfile);
        var data = {
            code: code,
            state: state,
            session_id: id,
            user_email: email,
            user_profile: perfil,
            xml_id: xmlId
        };
        var resultSignature = await SignatureService.sign(data, 'recibo')

        if (resultSignature.data.status === "success") {
            handleButtonState(false)
            message("success", resultSignature.data.data);
            if (userProfile == 'director' || userProfile == 'rh') {
                setTimeout(async () => {
                    await handleNotificar()
                }, 3000);
            }
        } else {
            handleButtonState(false)
            message("error", resultSignature.data.data);
        }

        await LoadXML()

    } */

    async function handleCancelClose() {
        setOpenReject(false)
        return
    }

    async function addRejectionMessage() {
        var mensaje = document.getElementById('mensaje').value;
        if (!mensaje) return
        await XmlService.addRejection({
            xml_id: xmlId,
            user_email: userEmail,
            message: mensaje,
        }).then(async result => {
            handleRejectionMessage('')
            if (result.data.status == 'success') {
                message("success", result.data.message);
            } else {
                message("error", result.data.message);
            }
            await LoadXML()
            setOpenReject(false)
        }).catch(error => {
            console.log(error)
            let errorMessage = "Error inesperado";
            if (error.response !== undefined)
                errorMessage = error.response.data.data;
            message("error", errorMessage);
        });
    }

    function SelectInvoice(value) {
        let viewOption = "";
        if ((Object.entries(value.employee).length > 0) && (Object.entries(value.company).length > 0) && (Object.entries(value.xml).length > 0) && (value.detail.length > 0)) {
            viewOption = <ModernInvoicePagePago control={value.control} document={value.document} employee={value.employee} company={value.company} detail={value.detail} xml={value.xml}></ModernInvoicePagePago>
        } else {
            viewOption = <div></div>
        }
        return viewOption;
    }

    async function handleClickOpenReject() {
        setOpenReject(true);
    }

    async function handleDownloadPdf() {
        handleButtonStateDownloadPdf(true)

        let data = {
            xmlId
        };

        await XmlService.downloadPDF(data).then(response => {

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Recibo_nro_${xml.numero_recibo}_${xml.fecha_de_pago}.pdf`);
            document.body.appendChild(link);
            link.click();
            handleButtonStateDownloadPdf(false)

        }).catch(error => {
            handleButtonStateDownloadPdf(false)
            console.log(error)
            let errorMessage = "Error inesperado";
            if (error.response !== undefined)
                errorMessage = error.response.data.message;
            message("error", errorMessage);
        });

    }

    async function handleDownloadXml() {
        handleButtonStateDownloadXml(true)

        let data = {
            xmlId
        };

        await XmlService.downloadXML(data).then(response => {

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Recibo_nro_${xml.numero_recibo}_${xml.fecha_de_pago}.xml`);
            document.body.appendChild(link);
            link.click();
            handleButtonStateDownloadXml(false)

        }).catch(error => {
            handleButtonStateDownloadXml(false)
            console.log(error)
            let errorMessage = "Error inesperado";
            if (error.response !== undefined)
                errorMessage = error.response.data.message;
            message("error", errorMessage);
        });

    }


    return (
        <div className={clsx(classes.root, "flex-grow flex-shrink-0 p-0 sm:p-64 print:p-0")}>

            <Paper className="p-12 mb-24 hidden-print">
                <Tooltip title="Volver" placement="top">
                    <IconButton onClick={() => props.history.push('/document-list')}>
                        <Icon>arrow_back</Icon>
                    </IconButton>
                </Tooltip>
                {(renderIf(xml.status !== 'DES'))(
                    <>
                        <Tooltip placement="top">
                            <span>
                                <IconButton title="Descargar PDF"
                                    onClick={() => { handleDownloadPdf() }}
                                >
                                    {buttonStateDownloadPdf ? <CircularProgress size={20} />
                                        :
                                        <>
                                            <Icon>picture_as_pdf</Icon>
                                        </>}
                                </IconButton>
                            </span>
                        </Tooltip>

                        <Tooltip placement="top">
                            <span>
                                <IconButton title="Descargar XML"
                                    onClick={() => { handleDownloadXml() }}
                                >
                                    {buttonStateDownloadXml ? <CircularProgress size={20} />
                                        :
                                        <>
                                            <Icon>cloud_download</Icon>
                                        </>}
                                </IconButton>
                            </span>
                        </Tooltip>
                    </>
                )}

                {renderIf((userProfile == 'rh' || userProfile == 'rh_not_signer') && xml.status == 'PEN')(
                    <Tooltip title="Desactivar documento" placement="top">
                        <IconButton
                            onClick={() => setDeactivateOpen(true)}
                        >
                            <Icon>block</Icon>
                        </IconButton>
                    </Tooltip>
                )}
            </Paper>


            {/* <Dialog open={open} onClose={handleCancelClose} maxWidth={1000} >
                <DialogContent>
                    <iframe src={authUrl} width={1000} height={600}></iframe>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelClose} color="primary">
                        Cancelar
                    </Button>
                </DialogActions>
            </Dialog> */}

            <Dialog open={deactivateOpen} onClose={handleDeactivateClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-deactivate-dialog-title">Desactivar documento</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Por favor, ingrese el motivo de la desactivación del documento.
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="motivoDesactivacion"
                        label="Motivo"
                        value={motivoDesactivacion}
                        onChange={e => handleMotivoDesactivacion(e.target.value)}
                        fullWidth
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeactivateCancelClose} color="primary">
                        Cancelar
                    </Button>
                    <Button onClick={handleDeactivateClose} color="primary">
                        Desactivar Documento
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openReject} onClose={handleCancelClose} classes={{ paper: classes.dialogPaper }} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">RECHAZAR RECIBO</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Estas seguro de rechazar el recibo?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelClose} color="primary">
                        Cancelar
                    </Button>
                    <Button onClick={addRejectionMessage} color="primary">
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>

            {(renderIf(xml.motivoDesactivacion))(
                <Card className="mx-auto w-xl print:w-full print:shadow-none mb-24">

                    <CardContent className="p-88 print:p-0">

                        <div className="flex flex-row justify-between items-start">

                            <div className="flex flex-col">
                                <div className="flex items-center">
                                    <Typography variant="h5" className="font-light print:text-16" color="textSecondary">¡DOCUMENTO DESACTIVADO!</Typography>
                                </div>
                            </div>
                        </div>

                        <div className="print:mt-0">
                            <Typography variant="h6" className="font-light print:text-16" color="textSecondary">Motivo de desactivación</Typography>
                            {xml.motivoDesactivacion}
                        </div>
                    </CardContent>
                </Card>
            )}

            {(userProfile === 'funcionario' || (userProfile === 'rh' && rejections.length > 0)) && (
                <Card className="mx-auto w-xl print:w-full hidden-print mb-24">
                    <CardContent className="p-88 print:p-0">
                        <div className="flex flex-row justify-between items-start">
                            <div className="flex flex-col">
                                <div className="flex items-center">
                                    <Typography variant="h5" className="font-light print:text-16" color="textSecondary">RECHAZOS</Typography>
                                </div>
                            </div>
                        </div>

                        <div className="mt-44 print:mt-0">
                            <Table className="simple">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="left">MENSAJE</TableCell>
                                        <TableCell align="right">FECHA Y HORA</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rejections.map((rejection) => (
                                        <TableRow key={rejection.id}>
                                            <TableCell>{rejection.message}</TableCell>
                                            <TableCell align="right">
                                                {moment(rejection.created_at).local(momentESLocale).format("DD/MM/YYYY HH:mm")}
                                            </TableCell>
                                        </TableRow>
                                    ))}

                                    {/* Mostrar este formulario solo si es 'funcionario', no tiene rechazos y el estado es 'ENP' */}
                                    {rejections.length === 0 && userProfile === 'funcionario' && xml.status === 'ENP' && (
                                        <TableRow className="hidden-print">
                                            <TableCell colSpan="2">
                                                <TextField
                                                    id="mensaje"
                                                    label="Ingrese un mensaje de rechazo"
                                                    multiline
                                                    rowsMax="4"
                                                    margin="normal"
                                                    value={rejectionMessage}
                                                    fullWidth
                                                />
                                            </TableCell>

                                            <TableCell>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    className="w-224 mx-auto mt-16"
                                                    aria-label="Agregar Mensaje"
                                                    type="button"
                                                    onClick={handleClickOpenReject}
                                                >
                                                    RECHAZAR RECIBO
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </div>
                    </CardContent>
                </Card>
            )}

            {xml && (
                <FuseAnimate animation={{ translateY: [0, '100%'] }} duration={600}>
                    <Card className="mx-auto w-xl print:w-full print:shadow-none">
                        <SelectInvoice control={control} document={documentos} company={company} employee={employee} detail={xmlDetails} xml={xml}></SelectInvoice>
                        <CardContent className="p-88 print:p-0">

                            <Grid container spacing={3}>
                                <Grid item xs={12} md={12}>
                                    <Grid container spacing={3}>
                                        {renderIf(firmasView.rrhh_view)(
                                            <Grid item xs={12} md={12} className={classes.signatureColumn}>
                                                {renderIf(firmasHolografas.rrhh)(
                                                    <img style={{ height: '100px' }} src={process.env.REACT_APP_API_HOST + '/' + firmasHolografas.rrhh} />
                                                )}
                                                {renderIf(firmasView.rrhh_view)(
                                                    <Typography className="mb-24 print:mb-12" variant="body1">Firma RRHH:</Typography>
                                                )}
                                                {renderIf(firmasView.rrhh_view)(
                                                    <Typography className="mb-24 print:mb-12" variant="body1">{firmas.rrhh}</Typography>
                                                )}
                                            </Grid>
                                        )}

                                        {renderIf(firmasView.rrhh_view)(
                                            <Grid item xs={12} md={4} className={classes.signatureColumn}>
                                                {renderIf(firmasHolografas.director)(
                                                    <img style={{ height: '100px' }} src={process.env.REACT_APP_API_HOST + '/' + firmasHolografas.director} />
                                                )}
                                                {renderIf(firmasView.director_view)(
                                                    <Typography className="mb-24 print:mb-12" variant="body1">Firma Empleador:</Typography>
                                                )}
                                                {renderIf(firmasView.director_view)(
                                                    <Typography className="mb-24 print:mb-12" variant="body1">{firmas.director}</Typography>
                                                )}
                                            </Grid>
                                        )}

                                        {renderIf(firmasView.rrhh_view === false)(
                                            <Grid item xs={12} md={6} className={classes.signatureColumn}>
                                                {renderIf(firmasHolografas.director)(
                                                    <img style={{ height: '100px' }} src={process.env.REACT_APP_API_HOST + '/' + firmasHolografas.director} />
                                                )}
                                                {renderIf(firmasView.director_view)(
                                                    <Typography className="mb-24 print:mb-12" variant="body1">Firma Empleador:</Typography>
                                                )}
                                                {renderIf(firmasView.director_view)(
                                                    <Typography className="mb-24 print:mb-12" variant="body1">{firmas.director}</Typography>
                                                )}
                                            </Grid>
                                        )}

                                        {renderIf(firmasView.rrhh_view)(
                                            <Grid item xs={12} md={4} className={classes.signatureColumn}>
                                                {renderIf(firmasHolografas.empleado)(
                                                    <img style={{ height: '100px' }} src={process.env.REACT_APP_API_HOST + '/' + firmasHolografas.empleado} />
                                                )}
                                                {renderIf(firmasView.empleado_view)(
                                                    <Typography className="mb-24 print:mb-12" variant="body1">Firma Empleado:</Typography>
                                                )}
                                                {renderIf(firmasView.empleado_view)(
                                                    <Typography className="mb-24 print:mb-12" variant="body1">{firmas.empleado}</Typography>
                                                )}
                                            </Grid>
                                        )}

                                        {renderIf(firmasView.rrhh_view === false)(
                                            <Grid item xs={12} md={6} className={classes.signatureColumn}>
                                                {renderIf(firmasHolografas.empleado)(
                                                    <img style={{ height: '100px' }} src={process.env.REACT_APP_API_HOST + '/' + firmasHolografas.empleado} />
                                                )}
                                                {renderIf(firmasView.empleado_view)(
                                                    <Typography className="mb-24 print:mb-12" variant="body1">Firma Empleado:</Typography>
                                                )}
                                                {renderIf(firmasView.empleado_view)(
                                                    <Typography className="mb-24 print:mb-12" variant="body1">{firmas.empleado}</Typography>
                                                )}
                                            </Grid>
                                        )}

                                    </Grid>
                                </Grid>

                                {renderIf(signature_employee)(
                                    <Grid item xs={12} md={3}>
                                        <div className="mt-96 print:mt-0 print:px-16">
                                            <QRCode value={`${process.env.REACT_APP_PUBLIC_URL}/kuderecibohaberes/${hashKude}`} />
                                        </div>
                                    </Grid>
                                )}

                            </Grid>

                            {(renderIf(userProfile != 'rh_not_signer'))(
                                <Grid container spacing={3} className="hidden-print">
                                    <Grid item xs={12} md={12} style={{ 'textAlign': 'center' }}>
                                        <Button
                                            type="button"
                                            variant="contained"
                                            color="default"
                                            onClick={handleClickOpen}
                                            disabled={buttonFirmar}>
                                            <Icon>edit</Icon> FIRMAR RECIBO
                                        </Button>
                                    </Grid>
                                </Grid>
                            )}
                        </CardContent>
                    </Card>
                </FuseAnimate>
            )}
        </div>
    );
}

export default ModernInvoicePage;
